module.exports = __webpack_public_path__ + "static/media/claire2.a3ab5f71.jpg";